import { EgretLoadable } from "egret";

const adminBlockManagment = EgretLoadable({
  loader: () => import("./AdminBlockManagment")
});

const adminBlockManagmentRoutes = [
  {
        path: "/agentBlockManagment",
        component: adminBlockManagment
  }
];

export default adminBlockManagmentRoutes;
